export default "__VITE_ASSET__50c12cfd__"